import { render, staticRenderFns } from "./StudentClassesTab.vue?vue&type=template&id=6e6b0067&"
import script from "./StudentClassesTab.vue?vue&type=script&lang=js&"
export * from "./StudentClassesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports